import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PlannedActualCard = ({
  icon,
  title,
  planned,
  actual,
  color = "#0d9488",
  showIconCircle = true,
  className = "",
}) => (
  <div className={`pd-plan-card ${className}`.trim()}>
    <div className="pd-plan-head">
      {showIconCircle ? (
        <span className="pd-stat-icon" style={{ background: color, marginBottom: 0 }}>
          <FontAwesomeIcon icon={icon} />
        </span>
      ) : (
        <FontAwesomeIcon
          icon={icon}
          className="pd-plan-icon"
          style={{ color, fontSize: "1.1rem" }}
        />
      )}
      <span className="pd-plan-title">{title}</span>
    </div>
    <div className="pd-plan-counts">
      <div>
        <small>Planned Count</small>
        <strong style={{ color }}>{planned}</strong>
      </div>
      <div>
        <small>Actual Count</small>
        <strong style={{ color }}>{actual}</strong>
      </div>
    </div>
  </div>
);

export default PlannedActualCard;
